export const nonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('content') || undefined;
